module.exports = __webpack_public_path__ + "fcb20dfd096c2d1d1ba6720c482eed1a.png";